import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { useConfigFetch } from '#hook/use-config-fetch';
import { useRouteMatch } from '#hook/use-route-match';
import { usePrevious } from '#hook/use-previous';
import { rtkApi } from '#adapter/api/campaigns/v5/promotions/view/status';

export const useCheckNewPromotions = () => {
    const location = useLocation();
    const { match } = useRouteMatch();
    const previousPathname = usePrevious(location.pathname);

    const { config } = useConfigFetch();

    const { data, isLoading, isFetching, refetch } = rtkApi.endpoints.getPromotionsViewStatus.useQuery({}, {
        skip                     : !config?.personalCashbackEnabled,
        refetchOnMountOrArgChange: 2000
    });

    const [upDatePromotionsViewStatus] = rtkApi.endpoints.setPromotionsViewStatus.useMutation();

    useEffect(() => {
        if(data?.viewedAllNewPromotions === undefined || !!data?.viewedAllNewPromotions) {
            return;
        }

        const isPromotionsFirstPage = previousPathname?.includes('/campaigns/promotions');
        const isPromotionsCurrentPage = Boolean(match.campaigns.promotions);

        if((isPromotionsFirstPage && !isPromotionsCurrentPage) || (!isPromotionsFirstPage && isPromotionsCurrentPage)) {
            upDatePromotionsViewStatus({})
                .unwrap()
                .then(() => refetch())
                .catch(console.error);
        }
    }, [
        data?.viewedAllNewPromotions,
        match.campaigns.promotions,
        previousPathname,
        upDatePromotionsViewStatus,
        refetch
    ]);

    const isCommanLoadind = isLoading || isFetching;

    return {
        isNewPromotionsAvailable: !!config?.personalCashbackEnabled && data?.viewedAllNewPromotions === false && !isCommanLoadind
    };
};
